// Since the response can be typecasted to any type. Better approach is appreciated if any.

import { AxiosInstance } from 'axios';
import { GenericObject } from './platform';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface HttpResponse<T = any> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  request?: any;
}

export interface ErrorResponse {
  code: string;
  data: object;
  message: string;
  status: number;
  traceID: string;
}
export interface ReplayRequest {
  url: string;
  method: 'GET' | 'PUT' | 'POST' | 'DELETE';
  data: GenericObject;
}
export interface ErrorHandler {
  serverError: ErrorResponse;
  replayRequest: ReplayRequest;
  axiosInstance: AxiosInstance;
}

export enum RestErrorMessages {
  USER_PREMIUM_FORBIDDEN = 'USER_PREMIUM_FORBIDDEN',
  PARAPHRASER_SEGMENT_FAILURE = 'PARAPHRASER_SEGMENT_FAILURE',
  COM_STORAGE = 'COM_STORAGE',
  COM_FORBIDDEN = 'COM_FORBIDDEN',
  COM_TOO_MANY_REQUESTS = 'COM_TOO_MANY_REQUESTS',
}
